import React, { useState } from 'react';
import { useTour } from '../../contexts/TourContext';
import TourStep from './TourStep';
import TourProgress from './TourProgress';
import './TourOverlay.css';

const TourOverlay: React.FC = () => {
  const { state, closeTour } = useTour();
  const [isVisible, setIsVisible] = useState(false);

  // Prüfe ob der User eingeloggt ist
  const isAuthenticated = () => {
    const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
    return !!accessToken;
  };

  // Debug: Tour-State prüfen
  console.log('🔍 TourOverlay: state.isActive =', state.isActive);
  console.log('🔍 TourOverlay: state.currentStep =', state.currentStep);
  console.log('🔍 TourOverlay: Vollständiger State =', state);
  console.log('🔍 TourOverlay: isAuthenticated =', isAuthenticated());

  // Zeige Tour nur wenn der User eingeloggt ist UND die Tour aktiv ist
  if (!isAuthenticated()) {
    console.log('🔒 User nicht eingeloggt - zeige keine Tour');
    return null;
  }

  if (!state.isActive) {
    console.log('❌ Tour nicht aktiv - zeige nichts');
    return null;
  }

  console.log('✅ Tour ist aktiv - zeige Overlay');

  const handleSkip = () => {
    closeTour();
    // Tour wird einfach geschlossen - kein API-Call
  };

  const handleClose = () => {
    closeTour();
    // Tour wird einfach geschlossen - kein API-Call
  };

  return (
    <div className="tour-overlay">
      <div className="tour-backdrop" onClick={handleClose}></div>
      <div className="tour-content">
        <div className="tour-header">
          <div className="tour-title">
            <h2>🎯 AS Monitor Tour</h2>
            <p>Lerne die wichtigsten Funktionen kennen</p>
          </div>
          <div className="tour-actions">
            <button onClick={handleSkip} className="tour-skip-btn">
              Überspringen
            </button>
            <button onClick={handleClose} className="tour-close-btn">
              ✕
            </button>
          </div>
        </div>
        
        <TourProgress />
        <TourStep />
      </div>
    </div>
  );
};

export default TourOverlay;
